module.exports = __webpack_public_path__ + "static/img/login2.db6560c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/login2.png
// module id = 346
// module chunks = 0